import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth"; // Import Firebase Auth
import { getAnalytics } from "firebase/analytics"; // Import Firebase Analytics

// Your Firebase configuration
// Replace with your actual Firebase project config
const firebaseConfig = {
    apiKey: "AIzaSyAWKJlIzy0vuIYszIOEkHdRVro0VsTb45I",
    authDomain: "checkmenus.firebaseapp.com", // Temporarily reverted for OAuth fix
    databaseURL: "https://checkmenus-default-rtdb.firebaseio.com",
    projectId: "checkmenus",
    storageBucket: "checkmenus.firebasestorage.app", // Corrected bucket name
    messagingSenderId: "906095630065",
    appId: "1:906095630065:web:d8445c582ec4664c6efb50",
    measurementId: "G-LZXTFP92SC"
  };
  
// Initialize Firebase
console.log("Initializing Firebase with project ID:", firebaseConfig.projectId);
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app); // Initialize and export Auth
export const analytics = getAnalytics(app); // Initialize and export Analytics

export default app;